export const GET_USER_REQUEST = "GET_USER_REQUEST";
export const GET_USER_FOUND = "GET_USER_FOUND";
export const GET_USER_NOT_FOUND = "GET_USER_NOT_FOUND";

export const VALIDATE_OTP_REQUEST = "VALIDATE_OTP_REQUEST";
export const VALIDATE_OTP_SUCCESS = "VALIDATE_OTP_SUCCESS";
export const VALIDATE_OTP_FAILED = "VALIDATE_OTP_FAILED";

export const FORGET_VALIDATE_OTP_REQUEST = "FORGET_VALIDATE_OTP_REQUEST";
export const FORGET_VALIDATE_OTP_SUCCESS = "FORGET_VALIDATE_OTP_SUCCESS";
export const FORGET_VALIDATE_OTP_FAILED = "FORGET_VALIDATE_OTP_FAILED";

export const REGISTER_USER_REQUEST = "REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED";

export const FORGET_PASSWORD_REQUEST = "FORGET_PASSWORD_REQUEST";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_FAILED = "FORGET_PASSWORD_FAILED";

export const UPDATE_FORGET_PASSWORD_STATUS = "UPDATE_FORGET_PASSWORD_STATUS";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILED = "CHANGE_PASSWORD_FAILED";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED";

export const ACCOUNT_VERIFICATION_REQUEST = "ACCOUNT_VERIFICATION_REQUEST";
export const ACCOUNT_VERIFICATION_SUCCESS = "ACCOUNT_VERIFICATION_SUCCESS";
export const ACCOUNT_VERIFICATION_FAILED = "ACCOUNT_VERIFICATION_FAILED";

export const EMAIL_VERIFICATION_REQUEST = "EMAIL_VERIFICATION_REQUEST";
export const EMAIL_VERIFICATION_SUCCESS = "EMAIL_VERIFICATION_SUCCESS";
export const EMAIL_VERIFICATION_FAILED = "EMAIL_VERIFICATION_FAILED";

export const REGISTER_EXISTING_USER_REQUEST = "REGISTER_EXISTING_USER_REQUEST";
export const REGISTER_EXISTING_USER_SUCCESS = "REGISTER_EXISTING_USER_SUCCESS";
export const REGISTER_EXISTING_USER_FAILED = "REGISTER_EXISTING_USER_FAILED";

export const GET_EDITOR_REQUEST = "GET_EDITOR_REQUEST";
export const GET_EDITOR_SUCCESS = "GET_EDITOR_SUCCESS";
export const GET_EDITOR_FAILED = "GET_EDITOR_FAILED";

export const REMOVE_EDITOR_REQUEST = "REMOVE_EDITOR_REQUEST";
export const REMOVE_EDITOR_SUCCESS = "REMOVE_EDITOR_SUCCESS";
export const REMOVE_EDITOR_FAILED = "REMOVE_EDITOR_FAILED";

export const RESET_PASSWORD_STATUS = "RESET_PASSWORD_FAILED";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

export const ADD_MENU_ACTIVE_CLASS_REQUEST = "ADD_MENU_ACTIVE_CLASS_REQUEST";

export const CLEAR_AUTH_RESPONSE = "CLEAR_AUTH_RESPONSE";
export const ForgetPasswordAction = (data) => {
  return {
    type: FORGET_PASSWORD_REQUEST,
    payload: data,
  };
};

export const removeEditorDataAction = (data) => {
  return { type: REMOVE_EDITOR_REQUEST, payload: data };
};

export const getEditorDataAction = (data) => {
  return { type: GET_EDITOR_REQUEST, payload: data };
};
export const AddExisitingUser = (data) => {
  return { type: REGISTER_EXISTING_USER_REQUEST, payload: data };
};
export const StatusUpdate = () => {
  return {
    type: UPDATE_FORGET_PASSWORD_STATUS,
  };
};

export const ChangePassword = (data) => {
  return {
    type: CHANGE_PASSWORD_REQUEST,
    payload: data,
  };
};

export const ResetPasswordAction = (data) => {
  return {
    type: RESET_PASSWORD_REQUEST,
    payload: data,
  };
};

export const StatusResetData = () => {
  return {
    type: RESET_PASSWORD_STATUS,
  };
};

export const LoginAction = (data) => {
  return { type: GET_USER_REQUEST, payload: data };
};

export const ValidateOtpAction = (data) => {
  return { type: VALIDATE_OTP_REQUEST, payload: data };
};
export const ForgetValidateOtpAction = (data) => {
  return { type: FORGET_VALIDATE_OTP_REQUEST, payload: data };
};

export const RegisterAction = (data) => {
  return { type: REGISTER_USER_REQUEST, payload: data };
};

export const LogoutAction = () => {
  return { type: LOGOUT };
};

export const VerifyAccountAction = (data) => {
  return { type: ACCOUNT_VERIFICATION_REQUEST, payload: data };
};
export const VerifyEmailAction = (data) => {
  return { type: EMAIL_VERIFICATION_REQUEST, payload: data };
};

export const ClearAuthResponse = () => {
  return { type: CLEAR_AUTH_RESPONSE };
};
